import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { matchPath, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { getUserSelector } from '@store/auth';
import { getGlobalVariableSelector } from '@store/global-variables';
import { BasketService, InitService, PopupsService } from '@services';
import { PrivateLayout, PublicLayout, WithSuspense } from '@hocs';
import { useSocket } from '@hooks';
import { Popups as PopupsEnum, Routes as RoutesEnum } from '@enums';
import { BasketComponent, Loader, Modals, Popups, Snackbars } from '@components';
import { MetaPage } from '@elements';
import 'react-reflex/styles.css';
import { appSocket } from './app.socket';
import { appPrivateRoutes, appPublicRoutes } from './routers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var AppComponent = function AppComponent() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAppReady = _useState2[0],
      setIsAppReady = _useState2[1];

  var navigate = useNavigate();

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname,
      search = _useLocation.search,
      hash = _useLocation.hash;

  var basket = useSelector(getGlobalVariableSelector('basket'));
  var user = useSelector(getUserSelector);
  var hadUserRef = useRef(!!user);
  useSocket(appSocket, []);
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(function () {
    if (user && !hadUserRef.current) {
      void BasketService.reloadBasket();
    }

    hadUserRef.current = !!user;
  }, [user]);
  useEffect(function () {
    var _params$get;

    var params = new URLSearchParams(search);
    var error = ((_params$get = params.get('error')) !== null && _params$get !== void 0 ? _params$get : '').trim();
    if (!error) return;
    void PopupsService.open(PopupsEnum.Default, {
      header: '',
      body: error,
      acceptButton: 'Понятно'
    })["finally"](function () {
      var nextParams = new URLSearchParams(search);
      nextParams["delete"]('error');
      var nextSearch = nextParams.toString();
      navigate("".concat(pathname).concat(nextSearch ? "?".concat(nextSearch) : '').concat(hash !== null && hash !== void 0 ? hash : ''), {
        replace: true
      });
    });
  }, [hash, navigate, pathname, search]);

  var hideSplashScreen = function hideSplashScreen() {
    var loader = document.getElementById('loader');

    if (loader) {
      window.appReady = true;
      setTimeout(function () {
        document.body.classList.remove('loading');
        setTimeout(function () {
          loader.style.visibility = 'hidden';
          loader.remove();
        }, 0);
      }, 100);
    }
  };

  useEffect(function () {
    InitService.init().then(function () {
      setIsAppReady(true);
      hideSplashScreen();
    })["catch"](function () {
      setIsAppReady(true);
      hideSplashScreen();
    });
  }, []);

  var isSectorOrSectorsPage = function isSectorOrSectorsPage() {
    return matchPath({
      path: RoutesEnum.Sector,
      end: true
    }, pathname) !== null || matchPath({
      path: RoutesEnum.Sectors,
      end: true
    }, pathname) !== null;
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Loader, {}), /*#__PURE__*/_jsx(MetaPage, {}), isAppReady ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Routes, {
        children: [appPrivateRoutes.map(function (route) {
          var _route$children;

          return /*#__PURE__*/_jsx(Route, {
            path: "/",
            element: /*#__PURE__*/_jsx(PrivateLayout, {
              inline: route.inline
            }),
            children: /*#__PURE__*/_jsx(Route, {
              path: route.path,
              element: WithSuspense(route.element),
              index: route.index,
              children: !!(route !== null && route !== void 0 && (_route$children = route.children) !== null && _route$children !== void 0 && _route$children.length) && route.children.map(function (childRoute) {
                return /*#__PURE__*/_jsx(Route, {
                  path: childRoute.path,
                  element: WithSuspense(childRoute.element),
                  index: childRoute.index
                }, childRoute.name);
              })
            })
          }, route.name);
        }), appPublicRoutes.map(function (route) {
          return /*#__PURE__*/_jsx(Route, {
            path: "/",
            element: /*#__PURE__*/_jsx(PublicLayout, {
              inline: route.inline,
              isFooterVisible: route.isFooterVisible
            }),
            children: /*#__PURE__*/_jsx(Route, {
              path: route.path,
              element: WithSuspense(route.element),
              index: route.index
            })
          }, route.name);
        })]
      }), /*#__PURE__*/_jsx(Modals, {}), /*#__PURE__*/_jsx(Popups, {}), /*#__PURE__*/_jsx(Snackbars, {}), (basket === null || basket === void 0 ? void 0 : basket.length) > 0 && isSectorOrSectorsPage() && /*#__PURE__*/_jsx(BasketComponent, {
        basket: basket
      })]
    }) : null]
  });
};

export default withTranslation()(AppComponent);